<template>
    <div class='container' data-content-type='container' :class="[{'page-builder-mode' : page_builder_mode, 'remove-guides-mode' : remove_guides}, classes.container]" :id='container.id' :container-sequence-id='container.sequence_number' :style='[container.compiled_styles, custom_styles.container, drag_padding_styles]'>
        <slot></slot>
    </div>
</template>

<script>
import format_custom_styles from "@/page_builder/builder/builder_tools/functions/format_custom_styles.js";

export default {
    components: {},
    props:['container', 'page_builder_mode', 'remove_guides'],
    mixins: [format_custom_styles],
    data(){
        return{
            drag_padding_styles: {},
            classes: []
        }
    },
    methods:{
        setClasses(){
            if(this.container.compiled_classes != null){
                this.classes = this.container.compiled_classes;
            }
        },
        setPaddingForDrag(){
            if(this.page_builder_mode){
                let padding = this.container.styles.padding.value;
                let split_padding = padding.split(' ');

                let top = split_padding[0];
                let right = split_padding[1];
                let bottom = split_padding[2];
                let left = split_padding[3];

                this.drag_padding_styles = { //Always set minium padding to allow for dragging
                    'padding-top': `max(16px, ${top})`,
                    'padding-bottom': `max(16px, ${bottom})`,
                    'padding-left': `max(4px, ${left})`,
                    'padding-right': `max(4px, ${right})`,
                };

                 if(this.remove_guides){
                    this.drag_padding_styles = { //Always set minium padding to allow for dragging
                    'padding-top': `max(0px, ${top})`,
                    'padding-bottom': `max(0px, ${bottom})`,
                    'padding-left': `max(0px, ${left})`,
                    'padding-right': `max(0px, ${right})`,
                };
                 }
            }
        }
    },
    watch:{
        'container': {
            handler(){  
                this.setCustomCssStyles(this.container.custom_styles); //From mixin
                this.setPaddingForDrag();
                this.setClasses();
            },
            deep: true
        },
        'remove_guides': function(){
            this.setPaddingForDrag();
        }
    },
    mounted(){
        this.setCustomCssStyles(this.container.custom_styles); //From mixin
        this.setPaddingForDrag();
        this.setClasses();
    }
}
</script>

<style lang="scss" scoped>
.container{
    display: flex;
    gap: 10px;
    box-sizing: border-box;

    @media(max-width: 768px){ //Hard coded - will need to be dynamic in future
        flex-wrap: wrap;
        flex-direction: row !important;
    }
    @container(width <= 768px) { //For page builder
        flex-direction: row !important;
        flex-wrap: wrap;
    }
}

.container.page-builder-mode{
    border: dashed 1px #59a985;
    border-radius: 5px;
    // min-height: 220px;
    width: 100%;
    box-sizing: border-box;
    position: relative;
}

.container.remove-guides-mode{
    border: none;
}

</style>